import React from "react";
import UserDashboardColumn from "./UserDashboardColumn";

class UserDashboardRow extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    if (!this.props.columns) {
      return null;
    }

    var columns = this.props.columns.map(function (column) {
      return (
        <UserDashboardColumn
          key={column.id}
          {...column}
          columnId={column.id}
          widgets={self.props.widgets}
          date={self.props.date}
          home_show={self.props.home_show}
          daily_rentals={self.props.daily_rentals}
        />
      );
    });

    return <div className="row">{columns}</div>;
  }
}

export default UserDashboardRow;
